import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Carousel } from '../../Generic/Carousel';
import BuyNowLiteDialog from '../../Generic/BuyNowLite/BuyNowLiteDialog';
import ListingCards from '../Product';
import styles from '../RelatedCollection/RelatedCollection-tw-styles';

// Only call useBinLite on client side
const getUseBinLite = () => {
  if (typeof window !== 'undefined') {
    return require('@procter-gamble/bin-lite-button').useBinLite;
  }
  return null;
};

const settings = {
  arrows: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  speed: 600,
  adaptiveHeight: false,
  infinite: false,
  lazyLoad: false,
  dots: true,
  draggable: true,
  autoplay: false,
  autoplaySpeed: 3000,
  prevArrow: <span className="glyphicon glyphicon-menu-left" />,
  nextArrow: <span className="glyphicon glyphicon-menu-right" />,
  responsive: [
    {
      breakpoint: 1023,
      settings: {
        arrows: false,
        dots: true,
        draggable: true,
        autoplay: false,
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        dots: true,
        draggable: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: false,
        arrows: false,
        verticalSwipping: false,
      },
    },
  ],
};

const ProductCarousel =(props)=>{
const [open,setOpen] = useState(false)
const [detachBNL, setDetachBNL] = useState(false)
const [buyNowData,setBuyNowData] = useState(null)
const [productData,setProductData] = useState({})
const [slidesToShowValue, setSlidesToShowValue] = useState(4)

  // Mobile detection - set slidesToShow based on viewport width
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setSlidesToShowValue(2);
        settings.arrows = false;
      } else if (window.innerWidth < 1024) {
        setSlidesToShowValue(3);
        settings.arrows = true;
      } else {
        setSlidesToShowValue(4);
        settings.arrows = true;
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleDialogViewState = async(data) => {
    setProductData(data);
    setBuyNowData(null)
    if (!open) {
          setOpen(true)
    } else {
      setOpen(false)
    }
    if (detachBNL) {
      onclick({ data: buyNowData });
    }
  };

  const closeDialog = () => {
    setOpen(false);
    setBuyNowData(null)
  };

    const { product, locale } = props;
    return (
      <div className={styles.collectionCarouselParent}>
        <Carousel
          {...settings}
          slidesToShow={slidesToShowValue}
          className={styles.collectionCarouselCardWidth}
          tabAdvancesSlides={true}
        >
          {product.relatedProductsCollection &&
            product.relatedProductsCollection.items.map(
              (productpage, index) => {
                return (
                  <ListingCards
                    locale={locale}
                    data={productpage}
                    key={index}
                    handleDialogViewState={handleDialogViewState}
                  />
                );
              }
            )}
        </Carousel>
        {!detachBNL ? (
          <BuyNowLiteDialog
            open={open}
            variant={
              productData &&
              productData.variantsCollection &&
              productData.variantsCollection.items
            }
            productShortName={productData && productData.productShortName}
            onCloseHandler={handleDialogViewState}
            buyNowData={buyNowData}
            productData={productData}
          />
        ) : null}
      </div>
    );
  }
// }

ProductCarousel.propTypes = {
  product: PropTypes.oneOfType([PropTypes.object]).isRequired,
  locale: PropTypes.string.isRequired,
};
export default ProductCarousel;